import React, {useState} from 'react'
import {Button, IconButton, Divider, Typography, Grid} from '@material-ui/core'
import '../../styles/Reservation/Reservation.scss'
import StepSelectItem from './StepSelectItem'
import StepSelectDate from './StepSelectDate'
import CloseIcon from '@material-ui/icons/Close'
import StepSelectAdditionalFields from './ReservationSteps/StepSelectAdditionalFields'
import StepConfirmReservation from './ReservationSteps/StepConfirmReservation'
import StepConfirmedReservation from './ReservationSteps/StepConfirmedReservation'

import StepDots from './StepDots'

const ItemFirst = ({onClose}) => {
  const [step, setStep] = useState(1)

  const [groupObjectIds, setGroupObjectIds] = useState([])
  const handleClickNext = () => {
    setStep(prev => prev + 1)
  }
  const handleClickPrev = () => {
    setStep(prev => prev - 1)
  }

  const handleEdit = step => {
    setStep(step)
  }

  return (
    <>
      <div
        className="c-res-mod ap-modal"
        style={
          step <= 3
            ? {width: 960, height: 'auto'}
            : step === 4
            ? {height: 610, width: 440, padding: '21px 0px 16px 32px'}
            : {width: 277, height: 156, padding: 5}
        }
      >
        <IconButton className="ap-icon-button ap-modal__btn-x" onClick={onClose}>
          <CloseIcon style={{color: '#1d2331'}} />
        </IconButton>
        {step <= 4 && (
          <div className="ap-modal__header" style={{marginBottom: 16}}>
            <div className="ap-modal__title">New Reservation</div>
          </div>
        )}
        <div className="ap-modal__body">
          {step === 1 && <StepSelectItem showDate={false} />}
          {step === 2 && <StepSelectDate />}
          {step === 3 && <StepSelectAdditionalFields />}
          {step === 4 && <StepConfirmReservation handleEdit={handleEdit} />}
        </div>
        <div style={{display: 'flex', flexDirection: 'row', paddingTop: 16}}>
          <div className="ap-flex ap-flex--start">
            {step > 1 && step < 4 && (
              <Button className="ap-button" onClick={handleClickPrev}>
                Back
              </Button>
            )}
          </div>
          <div className="ap-flex ap-flex--center">
            <StepDots step={step} stepCount={3} />
          </div>
          <div className="ap-flex ap-flex--end">
            {step < 3 && (
              <Button className="ap-button ap-button--primary" onClick={handleClickNext}>
                Next
              </Button>
            )}
            {step === 3 && (
              <Button className="ap-button ap-button--primary" onClick={handleClickNext}>
                Next
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ItemFirst
